import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { QaLocatorsModule } from '@metromarkets/sdk';
import { RouterModule } from '@angular/router';
import { MmTooltipModule } from '@metromarkets/components';
import { PipesModule } from '~app/modules/account/modules/orders-history/pipes/pipes.module';
import { AppLinkGaTrackingComponent } from '~shared/components/app-link-ga-tracking/app-link-ga-tracking.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    QaLocatorsModule,
    RouterModule,
    MmTooltipModule,
    PipesModule
  ],
  declarations: [
    AppLinkGaTrackingComponent
  ],
  exports: [
    AppLinkGaTrackingComponent
  ]
})

export class AppLinkGaTrackingModule {}
